import { Todo } from 'api/clients/TodoClient'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { TodoFormValues } from 'components/TodoForm/Types'
import { schema } from 'prose-core'
import { Mark } from 'prosemirror-model'
import { EditorView } from 'prosemirror-view'
import { DocStore } from 'stores/DocStore'

export type onTodoCreateCallback = (todo: Todo) => void

const addTodoMark = (mark: Mark, view: EditorView, overridePositionRange?: { from: number; to: number }) => {
  const {
    dispatch,
    state,
    state: { tr, selection },
  } = view
  let { from, to } = overridePositionRange ? overridePositionRange : selection
  if (selection.$from.node().type === schema.nodes.smartLink && to - from < selection.$from.node().nodeSize) {
    state.doc.nodesBetween(from, to, (node, pos) => {
      if (node.type === schema.nodes.smartLink) {
        from = pos
        to = pos + node.nodeSize
      }
    })
  }
  tr.addMark(from, to, mark)
  dispatch(tr)
}

export const createTodoMark =
  (
    view: EditorView,
    callback: () => void,
    overridePositionRange?: { from: number; to: number },
  ) =>
  (todo: Todo) => {
    const mark = schema.marks.task.create({ uuid: todo.uuid, color: `rgba(222, 244, 255, 1)` })

    callback()
    addTodoMark(mark, view, overridePositionRange)
  }

export const createTodoUuidOnNode =
  (view: EditorView, nodePos: number, callback: () => void) => (todo: Todo) => {
    const {
      dispatch,
      state: { tr },
    } = view
    callback()

    const node = tr.doc.nodeAt(nodePos)
    if (node) {
      tr.setNodeMarkup(nodePos, undefined, {
        ...node.attrs,
        taskUuids: [...node.attrs.taskUuids, todo.uuid],
      })
      dispatch(tr)
    }
  }

export const createTodoSubmit =
  (from: number, to: number, docStore: DocStore, onCreateCallback: onTodoCreateCallback) =>
  async (values: TodoFormValues, mentionedUserIds: number[]) => {
    const assigneeId = values.assignee?.id || mentionedUserIds[0]

    const payload = {
      dueDate: values.dueDate,
      assigneeId,
      title: values.title,
      htmlTitle: values.htmlTitle,
      description: values.description,
      htmlDescription: values.htmlDescription,
      mentionedIds: mentionedUserIds,
      from: from,
      to: to,
    }

    try {
      const newTodo = await docStore.rootStore.todos.create(docStore.articleId, payload, true)
      if (newTodo) onCreateCallback(newTodo)
    } catch (e) {
      showErrorMessageToast('An error occurred, please try again.')
    }
  }
